import { TUser } from "@/services"
import { ACTION } from "./action"
import { TAppState, TAction, TTrackingPageZone } from "./types"

import { ACCESS_TOKEN_LENGTH } from "@/common/constant"
import { IJobDetail, TJobInvitation, TJobSpecialInfo } from "@/services/jobs/type"
import { decrypt } from "@microfrontends/react-components/components/Utils/helpers"

export const jobDetailReducer = (state: TAppState, action: TAction): TAppState => {
    const { type, payload } = action

    switch (type) {
        case ACTION.SET_USER: {
            const user = payload as TUser
            user.accessToken = user.accessToken.length === ACCESS_TOKEN_LENGTH ? user.accessToken : decrypt(user.accessToken)

            return { ...state, user: user }
        }
        case ACTION.SET_SAVED_JOB: {
            return { ...state, isSavedJob: payload as boolean }
        }
        case ACTION.SET_JOB_INVITATION: {
            return { ...state, jobInvitation: payload as TJobInvitation }
        }
        case ACTION.SET_TRACKING_PAGE_ZONE: {
            const trackingPageZone = payload as TTrackingPageZone

            return { ...state, trackingPageZone: trackingPageZone }
        }
        case ACTION.SET_IGNORE_JOB_IDS: {
            state.ignoreJobIds = payload as number[]
            return state
        }
        case ACTION.SET_ENABLE_TRACKING_AB: {
            const isEnableTracking = payload as boolean

            return { ...state, enableTrackingAB: isEnableTracking }
        }
        case ACTION.SET_SHOW_APPLY_JOB_MODAL: {
            const isShowModalApplyJob = payload as boolean
            return { ...state, isShowModalApplyJob: isShowModalApplyJob }
        }
        case ACTION.SET_SHOW_JOB_MATCHING_MODAL: {
            const isShow = payload as boolean

            return { ...state, isShowJobMatchingModal: isShow }
        }
        case ACTION.SET_JOB_DETAIL: {
            const jobDetail = payload as Partial<IJobDetail>
            return { ...state, jobDetail }
        }
        case ACTION.SET_SPECIAL_JOB: {
            const specialJobsResponse = payload as Partial<TJobSpecialInfo>
            const specialJobs = specialJobsResponse.attributes
            return {
                ...state,
                isSavedJob: specialJobs?.saved ?? false,
                isAppliedJob: specialJobs?.applied ?? false,
                checkBlacklist: specialJobs?.userBlackList ?? false
            }
        }
        default:
            console.error('Unknown type of Reducer')
            return { ...state }
    }
}
